<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>{{ $t('gestaocurso.TipoCurso') }}</h1>
        </div>
        <div class="flex xs12 sm12 lg3">
          <va-button class="text-right" @click="abrirNovo()"  :color="BuNovo.color" :style="BuNovo"> {{ $t('Geral.Novo') }}</va-button>
        </div>
  </div>

  <div v-if="novo">
          <form>
              <div class="row">
                <div class="flex md5 sm12 xs12">
                  <va-input
                    v-model="simple"
                    placeholder="Nombre del curso "
                  />
                </div>

                <div class="flex md5 sm12 xs12">
                  <va-input
                    v-model="simple"
                    placeholder="Nombre del curso "
                  />
                </div>
                <div class="flex md2 sm12 xs12 text-center">
                    <va-button class="text-right" @click="abrirNovo()"  color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                </div>
              </div>

          </form>

  </div>
 
    <va-data-table
          :fields="fields"
          :data="users"
          hoverable
          no-pagination
          >
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">
                <va-button flat small color="gray" @click="edit(props.rowData)" class="ma-0">
                  {{ $t('tables.edit') }}
                </va-button>

                <va-button flat small color="danger" @click="remove(props.rowData)" class="ma-0">
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
              
        </va-data-table>

   

</div>

      
 
</template>

<script>
//import cursos from './Cursos'

export default {
  name: 'cursos',
  
  components: {
  
  },

  data () {
      return {
        users: users.slice(0, 6),
        BuNovo: {
          color:'info',
          'width': '100%',
        }, 
        novo: false,
     
      }
    },
    created(){
      console.log(users)
    },
  computed: {
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'fullName',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'email',
          title: this.$t('tables.headings.email'),
        }, {
          name: 'country',
          title: this.$t('tables.headings.country'),
        },{
          name: 'acion',
          dataClass: 'text-right',
          title: this.$t('tables.headings.country'),
         
        }, {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  },

  methods: {
      abrirNovo (){
        this.novo = !this.novo
      },
 
  },
}
</script>

<style lang="scss">

</style>
